import { customScrollMinimal, Modal } from '@toggle/design-system';
import styled from 'styled-components';

export const StyledModal = styled(Modal)`
  [data-modal-container] {
    display: flex;
    flex-direction: column;
    width: max(35%, 1216px);
    max-height: calc(100% - 80px);
  }
`;

export const ContentWrapper = styled.div`
  height: 100%;
  overflow-y: scroll;
  ${customScrollMinimal};
`;

export const StyledSkeletonLoaderWrapper = styled.div`
  height: 750px;
`;

export const styledSkeletonLoaderAreas = [
  {
    styles: {
      width: '100%',
      height: '100%',
      borderRadius: '8px',
    },
  },
];
